// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220635/js/" + chunkId + "." + {"44":"cb9a4b79","225":"76903d6a","481":"626de105","486":"97d64a46","770":"f18e6967"}[chunkId] + ".0.519758102821288.chunk.js";
};